export const HISTORY_SOURCE = 'historySource';
export const PREV_CS_QUERY = 'previousCSQueryParams';
export const PREV_BLOG_QUERY = 'previousBlogQueryParams';
